/**
 * Build links that open the Namastay booking engine.
 *
 * The SDK reads the booking parameters from the href of a link, which has to be
 * an absolute URL. Without JavaScript the link reloads the current page with
 * `namastay=true`, which also opens the booking engine.
 *
 * @returns {Object} With bookingUrl method.
 */
export const useNamastay = () => {
	const config = useRuntimeConfig();
	const route = useRoute();
	const { locale } = useI18n();

	/**
	 * @param {Object} [params] Booking parameters, like roomId, adult, arrive and depart.
	 * @returns {string} Absolute URL to the current page with the booking parameters.
	 */
	const bookingUrl = (params = {}) => {
		const query = new URLSearchParams({ namastay: 'true', lang: locale.value, ...params });

		return `${config.public.siteUrl}${route.path}?${query}`;
	};

	return { bookingUrl };
};
